import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'sbb-page-not-found',
  templateUrl: './page-not-found.component.html',
  styleUrls: ['./page-not-found.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
// redirect to an unexisting url in sbb domain => sbb page not found will be shown
/*
  FPLZF-857
  Die html-seite dieser component ist ab sbb 404-seite kopiert. Draus wurden das suchbegrifffeld und das link zur homepage entfernt
  sie wird angezeigt, wenn das fehler in einem iframe passiert
  normalerweise wird bei fehler die echte sbb 404-seite mittels redirect angezeigt.
  nun ist es so, dass wenn das fehler in einem iframe passiert, kriegen wir 2 konstellationen :
  * entweder verweigert das sbb.ch-domain die verbindung, wahrscheinlich ein security-check um missbräuche zu vermeiden
  * oder wenn nicht verweigert, erscheinen dann auch in iframe die menus und footer
 */
export class PageNotFoundComponent {
  constructor() {
    let languageCode = '';

    // try to retrieve user language in url.
    // if not found, do another try with the browser language
    // supporten languages are fr/it/en of default (without matching) de
    // aim ist to display the "not found"-page in user language
    const currentUrl = window.location.href;
    if (currentUrl.indexOf('/fr/') > 0) {
      languageCode = 'fr/';
    } else if (currentUrl.indexOf('/it/') > 0) {
      languageCode = 'it/';
    } else if (currentUrl.indexOf('/en/') > 0) {
      languageCode = 'en/';
    } else {
      const userLanguage = navigator.language;
      if (
        (userLanguage && userLanguage.startsWith('fr')) ||
        userLanguage.startsWith('it') ||
        userLanguage.startsWith('en')
      ) {
        languageCode = userLanguage.substring(0, 2) + '/';
      }
    }

    if (window.self === window.top) {
      // kein iframe-aufruf, wir machen ein redirect zur sbb-seite
      window.location.href = 'https://www.sbb.ch/' + languageCode + '404';
    }
    // else iframe, es wird die html-seite dieser component angezeigt
  }
}
